import React from "react";

export default function SplitSection({
  title,
  highlight,
  extratitle,
  subTitle,
  quote,
  descriptions = [],
  features = [],
  blockInfo,
  buttonText,
  onButtonClick,
  image,
  imagePosition = "left", // "left" | "right"
  bgColor = "#fff",
  textColor = "#000",
}) {
  const isImageLeft = imagePosition === "left";

  return (
    <section
      className="split-section py-5"
      style={{ '--background-color': bgColor, '--text-color': textColor }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* IMAGE */}
          <div
            className={`col-lg-6 mb-4 mb-lg-0 ${
              isImageLeft ? "" : "order-lg-2"
            }`}
          >
            <div className="text-center">
              <img src={image} alt="section" className="img-fluid" />
            </div>
          </div>

          {/* CONTENT */}
          <div className={`col-lg-6 ${isImageLeft ? "" : "order-lg-1"}`}>
            <div className="content-wrapper">
              {/* TITLE */}
              <h2 className="hero-title FS40FW600 mb-3">
                {title} <br />
                {highlight && (
                  <span className="text-success FS40FW600">{highlight}</span>
                )}
                {subTitle && (subTitle)}
              </h2>

              {extratitle && (
                <div>{extratitle()}</div>
              )}

              {/* QUOTE */}
              {quote && (
                <div className="quote-box FS18FW400 mb-3">
                  <p>{quote}</p>
                </div>
              )}

              {/* DESCRIPTION */}
              {descriptions.map((desc, i) => (
                <p className="desc" key={i}>
                  {desc}
                </p>
              ))}

              {/* LIST */}
              {features.length > 0 && (
                <ul className="feature-list">
                  {features.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}

              {blockInfo &&                
                  <div>
                    {blockInfo()}
                  </div>
                }

              {/* BUTTON */}
              {buttonText && (
                <div className="btn-wrapper mt-3">
                  <button className="primary-btn" onClick={onButtonClick}>
                    {buttonText}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="arrow"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
